import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-visitor-breakdown',
  templateUrl: './visitor-breakdown.component.html',
  styleUrls: ['./visitor-breakdown.component.scss'],
})
export class VisitorBreakdownComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set breakdownVisitorData(val: any) {
    if (val) {
      this.setupChart(val);
    }
  }
  height = '';
  chartOption: EChartsOption;

  setupChart(val: any) {
    let preApprovedCount = val.preApprovedCount;
    // .map((x) => x.preApprovedCount)
    // .reduce((acc, count) => acc + count, 0);
    let rapidVisitorCount = val.rapidVisitorCount;
    // .map((x) => x.rapidVisitorCount)
    // .reduce((acc, count) => acc + count, 0);
    let gateEntryCount = val.gateEntryCount;
    // .map((x) => x.gateEntryCount)
    // .reduce((acc, count) => acc + count, 0);
    let preVerifiedCount = val.preVerifiedCount;
    // .map((x) => x.preVerifiedCount)
    // .reduce((acc, count) => acc + count, 0);
    const isAllZero =
      preApprovedCount == 0 &&
      rapidVisitorCount == 0 &&
      gateEntryCount == 0 &&
      preVerifiedCount == 0;
    this.chartOption = {
      tooltip: {},
      xAxis: {
        type: 'category',
        data: ['Pre-Approved', 'Rapid-Visitor', 'Gate-Entry', 'Pre-Verified'],
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: 'Visitor Status',
          type: 'bar',
          data: [
            isAllZero ? 0 : preApprovedCount > 0 ? preApprovedCount : 0.01,
            isAllZero ? 0 : rapidVisitorCount > 0 ? rapidVisitorCount : 0.01,
            isAllZero ? 0 : gateEntryCount > 0 ? gateEntryCount : 0.01,
            isAllZero ? 0 : preVerifiedCount > 0 ? preVerifiedCount : 0.01,
          ],
          itemStyle: {
            color: (params) => {
              // Assign different colors to each bar
              const colorList = [
                '#ff5733', // Open
                '#33ff57', // Closed
                '#3357ff', // In Progress
                '#ff33a6', // On Hold
                '#33fff0', // Approved
                '#ff3333', // Rejected
                '#33ffbd', // Verified
                '#c033ff', // Snoozed
              ];
              return colorList[params.dataIndex];
            },
          },
        },
      ],
    };
  }
}
